<app-banner [isAPIDocsBanner]="true" [isDefaultPageBanner]="false" [banner]="banner"></app-banner>
<app-left-side-menu-api [pageTitle]="pageTitle" [href]="href" [apiName]="apiName" [tabName]="tabName" [isTabOverride]="isTabOverride"></app-left-side-menu-api>
